import React, { FC, FocusEvent, ChangeEvent } from 'react';
import { ListFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';
import useFirstUserAction from '../../hooks/useFirstUserActionState';
import CustomTextLabel from '../@shared/customTextLabel';

const CheckboxList: FC<ListFieldProps> = (props) => {
  const { field, tracker } = props;
  const hasAnyError = !!props.errors?.length;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const label = field.model.title;
  const id = field.valueField.id;
  const name = field.valueField.name;
  const triggerFirstInteractionGTMEvent = useFirstUserAction();

  const getNewValue = (currentValue: string[], targetValue: string): string[] =>
    currentValue.includes(targetValue) ? currentValue.filter((str) => str !== targetValue) : [...currentValue, targetValue];

  const onFocus = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onFocusField(field, getNewValue(props.value, e?.target?.value));
  };

  const onBlur = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onBlurField(field, getNewValue(props.value, e?.target?.value));
  };

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    props.onChange(field.valueField.name, getNewValue(props.value, e?.target?.value), props.isValid, []);
    triggerFirstInteractionGTMEvent();
  };
  const errorColor = hasAnyError ? 'error' : undefined;
  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--checkbox-list ${
        hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
      }`}
    >
      <label className="sitecore-jss-form__control__label--checkbox-list" htmlFor={id}>
        <CustomTextLabel label={label} tag="span" />
      </label>
      {field?.model?.items?.map((item) => (
        <React.Fragment key={item?.itemId}>
          <label className="sitecore-jss-form__control__label--checkbox-list">
            <input
              type="checkbox"
              value={item.value}
              name={name}
              className="sitecore-jss-form__field"
              onFocus={onFocus}
              onBlur={onBlur}
              onChange={onChange}
              checked={props.value.includes(item.value)}
              form="novalidatedform"
            />
            <Icon
              iconName={props.value.includes(item.value) ? 'action-checkbox-checked' : 'action-checkbox-default'}
              size={iconSize.dsk}
              color={errorColor}
              extraClassName="sitecore-jss-form__checkbox"
            />
            <CustomTextLabel label={`${item.text}`} tag="span" />
          </label>
        </React.Fragment>
      ))}
      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  );
};

export default CheckboxList;
